import PropTypes from 'prop-types';
import React, {Component} from 'react';
import DashboardApi from '../../../api/dashboard.jsx';
import Loader from '../loader.jsx';
import DataTable from '../dataTable.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import AdminOnly from 'ui/layout/AdminOnly';
import {makeCancelable} from 'helpers/cancelablePromise';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

class AnalysesByEmployee extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    start: PropTypes.any,
    end: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.array,
    POS: PropTypes.any,
  };

  static numericValue(value, addPadding) {
    return <div className={'numeric-box ' + (addPadding ? 'custom-padding-right' : '')} >{value}</div>;
  }

  constructor(props) {
    super(props);
    this.state = {
      report: null,
      loaded: false,
    };
  }

  componentDidMount() {
    this.onUpdate();
  }

  componentWillUpdate(nextProps) {
    if (nextProps.POS !== this.props.POS ||
    nextProps.branch !== this.props.branch ||
    nextProps.branches !== this.props.branches ||
    nextProps.start !== this.props.start ||
    nextProps.end !== this.props.end
    ) {
      this.onUpdate(nextProps);
    }
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  onUpdate(props = this.props) {
    const {branch, branches, start, end} = props;

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getAnalysesByEmployee(branch === -1 ? branches : branch,
        start, end)))
      .then(data => {
        this.setState({
          report: data,
          loaded: true,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          loaded: true,
        });
      });
  }

  render() {
    const {report, loaded} = this.state;
    let {formatMessage} = this.props.intl;

    return <div className='avg-test-account-report expanded-tile'>
      {report ?
        <Loader loaded={loaded}>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='report-header'>
                <AdminOnly>
                  <a className='dashboard-report-view-link pull-right'
                     href='#reports/water/analyses-by-employee'>
                    <span className='underline'><FormattedMessage id="general.view.report"/></span>
                    <i className='bl bl-right_arrow'/>
                  </a>
                </AdminOnly>
                <h2 className='title'><FormattedMessage id="general.analyses.employee"/></h2>
                <hr/>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='table-employee-tests table-biolab table-dashboard'>
                {!report.testsByEmployee || !report.testsByEmployee.length ?
                  <p><FormattedMessage id="posdashboard.error.no.data"/></p> :
                  <DataTable headerRow={[
                    formatMessage({id: 'general.employee'}),
                    formatMessage({id: 'general.store'}),
                    AnalysesByEmployee.numericValue(formatMessage({id: 'general.analyses'})),
                    AnalysesByEmployee.numericValue(formatMessage({id: 'general.analyses.problems'})),
                  ]}
                             className='table-footer-summary'
                             data={(report.testsByEmployee || [])
                               .map(row => [row.employeeName, row.storeName, AnalysesByEmployee.numericValue(row.analyses),
                                 AnalysesByEmployee.numericValue(row.analysesWithProblems, true)])}
                             footerRow={[
                               null,
                               formatMessage({id: 'general.total'}).toUpperCase(),
                               AnalysesByEmployee.numericValue(report.totalEmployeeAnalyses),
                               AnalysesByEmployee.numericValue(report.totalEmployeeAnalysesWithProblems, true),
                             ]}/>
                }
              </div>
            </div>
          </div>
        </Loader> :
        <div/>}
    </div>;
  }
}

export default injectIntl(bindLocaleUpdate(AnalysesByEmployee));
